import React, { useState } from "react";
import { Form, Modal, notification } from "antd";
import jsonfile from "../../../../../containers/yotta/vendor_management/vendor_info/vendor_info.json";
import { CisUI } from "../../../../../util/CISUI";
import InputFields from "../../../../../util/InputField";
import Config from "../../../../../util/config";
import axios from "../../../../../util/Api";

const CreateVendorModal = ({ visible, onClose, onSuccess }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const onchange = (e) => {
    if (e.hasOwnProperty("target")) {
      if (e.target.id === "input_shipping_address") {
        const checked = e.target.checked;
        if (checked) {
          const data = form.getFieldsValue([
            "billing_address_line_1", "billing_address_line_2",
            "billing_city", "billing_country", "billing_state", "billing_zipcode",
          ]);
          form.setFieldsValue({
            shipping_address_line_1: data.billing_address_line_1,
            shipping_address_line_2: data.billing_address_line_2,
            shipping_city: data.billing_city,
            shipping_country: data.billing_country,
            shipping_state: data.billing_state,
            shipping_zipcode: data.billing_zipcode,
          });
        } else {
          form.setFieldsValue({
            shipping_address_line_1: null, shipping_address_line_2: null,
            shipping_city: null, shipping_country: null,
            shipping_state: null, shipping_zipcode: null,
          });
        }
      }
    }
  };

  const onFinish = (values) => {
    setLoading(true);
    axios
      .post(Config.apiserver + jsonfile.urls.add, values, CisUI().HeaderRequest)
      .then((res) => {
        setLoading(false);
        if (res.data.status === 1) {
          notification.success({ message: "Success", description: res.data.msg });
          form.resetFields();
          onSuccess();
          onClose();
        } else {
          notification.warning({ message: "Alert", description: res.data.msg });
        }
      })
      .catch(() => {
        setLoading(false);
        notification.error({ message: "Error", description: "Something went wrong" });
      });
  };

  return (
    <Modal
      title={jsonfile.addtitle}
      open={visible}
      onCancel={() => { form.resetFields(); onClose(); }}
      onOk={() => form.submit()}
      confirmLoading={loading}
      okText="Create"
      width={"60%"}
      destroyOnClose
    >
      <style>{`.nmv-modal-form .ant-card { display: none; } .nmv-modal-form .ant-form button { display: none !important; }`}</style>
      <div className="nmv-modal-form">
        <Form
          form={form}
          {...CisUI().formItemLayout}
          name="vendor_input"
          className="ant-advanced-search-form"
          onFinish={onFinish}
          initialValues={{ remember: true }}
        >
          {InputFields(jsonfile.input, [], 0, { onchange }, "", "")}
        </Form>
      </div>
    </Modal>
  );
};

export default CreateVendorModal;
